import React from 'react'

const HomePage = () => {
  return (
    <div style={{marginTop:"9vh",textAlign:"center",display:"flex",flexDirection:"column",alignItems:"center",width:"99vw"}}>
      <h1>LeaderBoard-Pro</h1>
      <h3>A Project Under OpenLake</h3>
    </div>
  )
}

export default HomePage
